// extracted by mini-css-extract-plugin
module.exports = {"root":"bC_b","content":"bC_w","dividerAnimation":"bC_p"};